module.exports = "<ng-container *ngIf=\"item\">\n    <row-header [fullCopy]=\"true\" [row$]=\"item|meta\" [showCount]=\"true\" class=\"featured container header\"></row-header>\n    <div class=\"series-list\">\n        <episode-carousel [slides]=\"item.data\"></episode-carousel>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/series/series-list/series-list.template.html
// module id = 803
// module chunks = 2